import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-select-option-dialog',
  templateUrl: 'select-option.dialog.html',
  styleUrls: ['./select-option.dialog.scss']
})
export class SelectOptionDialog {

  feature: string;
  options: string[];
  current: string;

  custom: string = "";

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<SelectOptionDialog>,
      public dialog: MatDialog,
      ) {
        this.options = data.options;
        this.feature = data.feature;
        this.current = data.current;
      }

  selected(option: string) {
    this.dialogRef.close(option);
  }

}